import http from 'core/http-common'

import { INotRatedReservations, IRateItems, ISaveRateRequest } from 'types/RateType'

class RateService {
  getRateItems() {
    return http.get<IRateItems[]>(`Rate/GetRateItems`)
  }

  getNotRatedReservationsList() {
    return http.get<INotRatedReservations[]>(`Rate/GetNotRatedReservations`)
  }

  getNotRatedReservationPopup() {
    return http.get<INotRatedReservations>(`Rate/GetNotRatedReservationForPopup`)
  }

  saveRate(body: ISaveRateRequest) {
    return http.post(`Rate/Save`, body)
  }
}

export default new RateService()
